module.exports = __webpack_public_path__ + "img/theBrands.0c46f457.svg";